const KNUTH_MULTIPLICATIVE_CONSTANT = 2654435761;

export function getJitterDelay(id, delayMs){
  const hash = Math.imul(id, KNUTH_MULTIPLICATIVE_CONSTANT) >>> 0;
  return hash % delayMs;
}

export function sleep(ms) {
  return ms > 0 ? new Promise((resolve) => setTimeout(resolve, ms)) : Promise.resolve();
}